import {Suspense, lazy, FC} from 'react'
import {Routes, Route, Navigate} from 'react-router-dom'
import {DashboardWrapper} from 'app/modules/dashboard/DashboardWrapper'
import {MainDrawer, SplashScreen} from 'app/components'
import {useAuth} from 'app/modules/auth/auth'

type Props = {
  children?: any
}
const SuspensedView: FC<Props> = ({children}) => {
  return <Suspense fallback={<SplashScreen />}>{children}</Suspense>
}
export function PrivateRoutes() {
  const {toggleDrawer} = useAuth()
  const UserProfilePage = lazy(() => import('../modules/users/profile'))
  const TokenResult = lazy(() => import('../modules/tokenResult'))

  return (
    <>
      {toggleDrawer && <MainDrawer />}
      <Routes>
        <Route path='/dashboard' element={<DashboardWrapper />} />
        <Route
          path='/profile'
          element={
            <SuspensedView>
              <UserProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='onboarded'
          element={
            <SuspensedView>
              <TokenResult />
            </SuspensedView>
          }
        />
        <Route path='*' element={<Navigate to='/dashboard' />} />
      </Routes>
    </>
  )
}
